













    import axios from 'axios';
    import { Component, Prop, Vue } from 'vue-property-decorator';
    import { Category } from '@/models/catalog/Category';

    import CategoryItem from '@/components/App/Catalog/CategoryItem.vue';

    @Component({
		components: {
            'app-category': CategoryItem,
		},
	})
    export default class SubCategoryList extends Vue {
        public categories: Category[] = [];
        public category: Category|null = null;

        public fetchCategories () {
            axios.get(`/catalog/subcategories/${this.$route.params.category}`)
                .then((response) => {
                    this.categories = response.data;
                })
                .catch((error) => {
                    this.$store.dispatch('shared/error', error.response);
                });
        }

        public fetchCategory () {
            axios.get(`/catalog/category/${this.$route.params.category}`)
                .then((response) => {
                    this.category = response.data;
                })
                .catch((error) => {
                    this.$store.dispatch('shared/error', error.response);
                });
        }

        public created () {
            this.fetchCategories();
            this.fetchCategory();
        }
    }
